const Type = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
  routes: [
    {
      path: '/proj/type',
      name: 'proj_type',
      component: Type
    }
  ]
}
